import Times from '~/bootcamp/Activities/components/Times'
import { range } from '~/utils/helpers'

export default function ExpressionInternationalWithComma({
  multiplier,
  multiplicand,
}: {
  multiplier: string
  multiplicand: string
}): React.ReactElement {
  const multiplierStr = multiplier.split(/[,.]/).join('')
  const multiplicandStr = multiplicand.split(/[,.]/).join('')
  const multiplierCommaIndexOffset = multiplier.slice().search(/[,.]/)
  const multiplicandCommaIndexOffset = multiplicand.slice().search(/[,.]/)

  const multiplierGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${multiplierStr.length}, minmax(0, 1fr))`,
  }

  const multiplicandGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${multiplicandStr.length}, minmax(0, 1fr))`,
  }

  return (
    <span className="w-full self-end flex flex-col text-center text-md sm:text-lg font-semibold text-purple">
      <div className="relative self-end" style={multiplierGridStyle}>
        <div className="absolute inset-0 text-left flex items-center justify-evenly pointer-events-none ">
          {range(multiplierStr.length).map((key, index) =>
            key === multiplierCommaIndexOffset ? (
              <div className="w-8 sm:w-10 transform -translate-x-1" key={`multiplier-${key}`}>
                .
              </div>
            ) : (
              <span className="w-8 sm:w-10 transform -translate-x-1" key={`multiplier-${index}`} />
            ),
          )}
        </div>
        {range(multiplierStr.length).map((index) => (
          <span className="w-8 sm:w-10" key={`multiplier2-${index}`}>
            {multiplierStr[index]}
          </span>
        ))}
      </div>

      <div className="w-full flex justify-between items-center">
        <Times />
        <div className="relative">
          <div className="absolute inset-0 text-left flex items-center justify-evenly pointer-events-none ">
            {range(multiplicandStr.length).map((key, index) =>
              key === multiplicandCommaIndexOffset ? (
                <div className="w-8 sm:w-10 transform -translate-x-1" key={`multiplicand-${key}`}>
                  .
                </div>
              ) : (
                <span className="w-8 sm:w-10 transform -translate-x-1" key={`multiplicand-${index}`} />
              ),
            )}
          </div>
          <div style={multiplicandGridStyle}>
            {range(multiplicandStr.length).map((index) => (
              <span className="w-8 sm:w-10" key={`multiplicand2-${index}`}>
                {multiplicandStr[index]}
              </span>
            ))}
          </div>
        </div>
      </div>
    </span>
  )
}
